import { RaisinContainer as Container, Link, Typography } from '@raisin/components-lib';
import { getLocale } from '@raisin/cp-utils';
import { trackEvent } from '@raisin/events-tracking';
import { useT } from '@transifex/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { EVENTS } from '../../../../eventsTracking';
import { APP_STORE_BADGES, PLAY_STORE_BADGES } from './images';
import messages from './messages';
import * as S from './styles';
export const getIOSLocale = (iosLocale) => {
    if (iosLocale === getLocale('en').region) {
        return '';
    }
    return `${iosLocale}/`;
};
const MobileBanner = ({ mobileBannerIconURL }) => {
    var _a, _b;
    const intl = useIntl();
    const { region } = getLocale(intl.locale);
    const t = useT();
    const AppStoreBadge = (_a = APP_STORE_BADGES[region]) !== null && _a !== void 0 ? _a : APP_STORE_BADGES[getLocale('en').region];
    const PlayStoreBadge = (_b = PLAY_STORE_BADGES[region]) !== null && _b !== void 0 ? _b : PLAY_STORE_BADGES[getLocale('en').region];
    return (React.createElement(S.Background, null,
        React.createElement(Container, { maxWidth: "xl" },
            React.createElement(S.Wrapper, null,
                mobileBannerIconURL && region !== getLocale('en-GB').region && (React.createElement(S.Icon, { src: mobileBannerIconURL, alt: "", loading: "lazy" })),
                React.createElement(S.Content, null,
                    React.createElement(S.TextWrapper, null,
                        React.createElement(S.Heading, null, t(messages.title)),
                        React.createElement(Typography, { variant: "body1" }, t(messages.text))),
                    React.createElement(S.ImagesWrapper, null,
                        React.createElement(Link, { rel: "noreferrer noopener", target: "_blank", onClick: () => trackEvent(EVENTS.ANDROID_APP_ICON_BADGE_TAPPED), href: "https://play.google.com/store/apps/details?id=com.raisin.app" },
                            React.createElement(PlayStoreBadge, null)),
                        React.createElement(Link, { rel: "noreferrer noopener", target: "_blank", onClick: () => trackEvent(EVENTS.IOS_APP_ICON_BADGE_TAPPED), href: `https://apps.apple.com/${getIOSLocale(region)}app/id1515520813` },
                            React.createElement(AppStoreBadge, null))))))));
};
export default MobileBanner;
//# sourceMappingURL=index.js.map